/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.name}'s avatar`
};

const fr_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Avatar de ${i.name}`
};

const de_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Avatar von ${i.name}`
};

const es_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Avatar de ${i.name}`
};

const it_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `L'avatar di ${i.name}`
};

const ar_avatar_alt9 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `الصورة ${i.name} الرمزية ل`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const avatar_alt9 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.avatar_alt9(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("avatar_alt9", locale)
	if (locale === "en") return en_avatar_alt9(inputs)
	if (locale === "fr") return fr_avatar_alt9(inputs)
	if (locale === "de") return de_avatar_alt9(inputs)
	if (locale === "es") return es_avatar_alt9(inputs)
	if (locale === "it") return it_avatar_alt9(inputs)
	return ar_avatar_alt9(inputs)
};
export { avatar_alt9 as "AVATAR_ALT" }